export default __webpack_public_path__ + "static/media/search.68b7891d.svg";